import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import queryString from 'query-string';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import database from '@app/services/database';
import ProjectedOutcomesView from './ProjectedOutcomesView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

const euroFormatter = new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
});
class ConnectedProjectedOutcomesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Projected Outcomes
            marketExpansion: '',
            turnoverYear1: '',
            turnoverYear2: '',
            turnoverYear3: '',
            fullTimeStaffYear1: '',
            fullTimeStaffYear2: '',
            fullTimeStaffYear3: '',
            partTimeStaffYear1: '',
            partTimeStaffYear2: '',
            partTimeStaffYear3: '',
            validationErrors: {
                // Projected Outcomes
                marketExpansion: { show: false, check: null, errorMessage: ''  },
                turnoverYear1: { show: false, check: null, errorMessage: ''  },
                turnoverYear2: { show: false, check: null, errorMessage: ''  },
                turnoverYear3: { show: false, check: null, errorMessage: ''  },
                fullTimeStaffYear1: { show: false, check: null, errorMessage: ''  },
                fullTimeStaffYear2: { show: false, check: null, errorMessage: ''  },
                fullTimeStaffYear3: { show: false, check: null, errorMessage: ''  },
                partTimeStaffYear1: { show: false, check: null, errorMessage: ''  },
                partTimeStaffYear2: { show: false, check: null, errorMessage: ''  },
                partTimeStaffYear3: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };
        // Projected Outcomes
        this.handleMarketExpansion = this.handleMarketExpansion.bind(this);
        this.handleTurnoverYear1 = this.handleTurnoverYear1.bind(this);
        this.handleTurnoverYear2 = this.handleTurnoverYear2.bind(this);
        this.handleTurnoverYear3 = this.handleTurnoverYear3.bind(this);
        this.handleFullTimeStaffYear1 = this.handleFullTimeStaffYear1.bind(this);
        this.handleFullTimeStaffYear2 = this.handleFullTimeStaffYear2.bind(this);
        this.handleFullTimeStaffYear3 = this.handleFullTimeStaffYear3.bind(this);
        this.handlePartTimeStaffYear1 = this.handlePartTimeStaffYear1.bind(this);
        this.handlePartTimeStaffYear2 = this.handlePartTimeStaffYear2.bind(this);
        this.handlePartTimeStaffYear3 = this.handlePartTimeStaffYear3.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.outcomes.')) {
                this.setState({
                    [localStorage.key(i).substring(18)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    // Projected Outcomes
    handleMarketExpansion(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.marketExpansion.show = true;
            validationErrors.marketExpansion.errorMessage = 'KEY SECTION! DO NOT LEAVE BLANK ON YOUR APPLICATION FORM!';
            validationErrors.marketExpansion.check = false;
        } 
        else if (value.length < 128) {
            validationErrors.marketExpansion.show = true;
            validationErrors.marketExpansion.errorMessage = 'KEY SECTION! You should give a decent amount of detail and information in this section.';
            validationErrors.marketExpansion.check = false;
        }
        else if (value.length < 256) {
            validationErrors.marketExpansion.show = true;
            validationErrors.marketExpansion.errorMessage = 'KEY SECTION! Getting there!';
            validationErrors.marketExpansion.check = false;
        }
        else if (value.length < 512) {
            validationErrors.marketExpansion.show = true;
            validationErrors.marketExpansion.errorMessage = 'KEY SECTION! Good stuff!';
            validationErrors.marketExpansion.check = false;
        }
        else {
            validationErrors.marketExpansion.show = false;
            validationErrors.marketExpansion.errorMessage = '';
            validationErrors.marketExpansion.check = true;
        }
        this.setState({ 
            marketExpansion: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.outcomes.marketExpansion', value);
    }

    // Projected Outcomes
    handleTurnoverYear1(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isTurnoverYear1Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null && value.trim().replace(/,/g, '') < 2000001;

        if (isTurnoverYear1Valid) {
            validationErrors.turnoverYear1.check = true;
            validationErrors.turnoverYear1.errorMessage = '';
            localStorage.setItem('tovsForm.outcomes.turnoverYear1', value);
        }
        else {
            validationErrors.turnoverYear1.check = false;
            validationErrors.turnoverYear1.errorMessage = 'The amount does not seem right. It should be an amount no more than than €2,000,000';
        }
        validationErrors.turnoverYear1.show = !isTurnoverYear1Valid;
        this.setState({
            turnoverYear1: value,
            validationErrors: validationErrors
        });
    }
    
    handleTurnoverYear2(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isTurnoverYear2Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null && value.trim().replace(/,/g, '');

        if (isTurnoverYear2Valid) {
            if (this.state.turnoverYear1 > 0 && value > this.state.turnoverYear1 * 1.3) {
                validationErrors.turnoverYear2.show = true;
                validationErrors.turnoverYear2.check = false;
                validationErrors.turnoverYear2.errorMessage = 'You are predicting more than a 30% increase in revenues. You will need to provide very good reasons.';
            }
            else {
                validationErrors.turnoverYear2.show = false;
                validationErrors.turnoverYear2.check = true;
                validationErrors.turnoverYear2.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.turnoverYear2', value);
        }
        else {
            validationErrors.turnoverYear2.show = true;
            validationErrors.turnoverYear2.check = false;
            validationErrors.turnoverYear2.errorMessage = 'The amount does not seem right. If it is much higher than the previous year, more than 20% to 30%, you will need to provide very good reasons.';
        }
        this.setState({
            turnoverYear2: value,
            validationErrors: validationErrors
        });
    }
    handleTurnoverYear3(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isTurnoverYear3Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null && value.trim().replace(/,/g, '');

        if (isTurnoverYear3Valid) {
            if (this.state.turnoverYear2 > 0 && value > this.state.turnoverYear2 * 1.3) {
                validationErrors.turnoverYear3.show = true;
                validationErrors.turnoverYear3.check = false;
                validationErrors.turnoverYear3.errorMessage = 'You are predicting more than a 30% increase in revenues. You will need to provide very good reasons.';
            }
            else {
                validationErrors.turnoverYear3.show = false;
                validationErrors.turnoverYear3.check = true;
                validationErrors.turnoverYear3.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.turnoverYear3', value);
        }
        else {
            validationErrors.turnoverYear3.show = true;
            validationErrors.turnoverYear3.check = false;
            validationErrors.turnoverYear3.errorMessage = 'The amount does not seem right. If it is much higher than the previous year, more than 20% to 30%, you will need to provide very good reasons.';
        }
        this.setState({
            turnoverYear3: value,
            validationErrors: validationErrors
        });
    }

    handleFullTimeStaffYear1(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isFullTimeStaffYear1Valid = value < 11 && value > -1;

        if (isFullTimeStaffYear1Valid) {
            validationErrors.fullTimeStaffYear1.check = true;
            validationErrors.fullTimeStaffYear1.errorMessage = '';
            localStorage.setItem('tovsForm.outcomes.fullTimeStaffYear1', value);
        }
        else {
            validationErrors.fullTimeStaffYear1.check = false;
            validationErrors.fullTimeStaffYear1.errorMessage = 'The amount does not seem right. It should be less than 10 full-time employees currently.';
        }
        validationErrors.fullTimeStaffYear1.show = !isFullTimeStaffYear1Valid;
        this.setState({
            fullTimeStaffYear1: value,
            validationErrors: validationErrors
        });
    }

    handleFullTimeStaffYear2(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isFullTimeStaffYear2Valid = value < 21 && value > -1;

        if (isFullTimeStaffYear2Valid) {
            if (this.state.fullTimeStaffYear1 > 0 && value > this.state.fullTimeStaffYear1 * 2) {
                validationErrors.fullTimeStaffYear2.show = true;
                validationErrors.fullTimeStaffYear2.check = false;
                validationErrors.fullTimeStaffYear2.errorMessage = 'You are predicting to more than doubling your current staff. You will need to provide very good reasons.';
            }
            else {
                validationErrors.fullTimeStaffYear2.show = false;
                validationErrors.fullTimeStaffYear2.check = true;
                validationErrors.fullTimeStaffYear2.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.fullTimeStaffYear2', value);
        }
        else {
            validationErrors.fullTimeStaffYear2.show = true;
            validationErrors.fullTimeStaffYear2.check = false;
            validationErrors.fullTimeStaffYear2.errorMessage = 'The amount does not seem right. It is almost certainly no more than double of what you have now.';
        }
        this.setState({
            fullTimeStaffYear2: value,
            validationErrors: validationErrors
        });
    }

    handleFullTimeStaffYear3(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isFullTimeStaffYear3Valid = value < 41 && value > -1;

        if (isFullTimeStaffYear3Valid) {
            if (this.state.fullTimeStaffYear2 > 0 && value > this.state.fullTimeStaffYear2 * 2) {
                validationErrors.fullTimeStaffYear3.show = true;
                validationErrors.fullTimeStaffYear3.check = false;
                validationErrors.fullTimeStaffYear3.errorMessage = 'You are predicting to more than doubling your staff from the previous year. You will need to provide very good reasons.';
            }
            else {
                validationErrors.fullTimeStaffYear3.show = false;
                validationErrors.fullTimeStaffYear3.check = true;
                validationErrors.fullTimeStaffYear3.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.fullTimeStaffYear3', value);
        }
        else {
            validationErrors.fullTimeStaffYear3.show = true;
            validationErrors.fullTimeStaffYear3.check = false;
            validationErrors.fullTimeStaffYear3.errorMessage = 'The amount does not seem right. It is almost certainly no more than triple of what you have now.';
        }
        this.setState({
            fullTimeStaffYear3: value,
            validationErrors: validationErrors
        });
    }

    handlePartTimeStaffYear1(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPartTimeStaffYear1Valid = value < 21 && value > -1;

        if (isPartTimeStaffYear1Valid) {
            validationErrors.partTimeStaffYear1.check = true;
            validationErrors.partTimeStaffYear1.errorMessage = '';
            localStorage.setItem('tovsForm.outcomes.partTimeStaffYear1', value);
        }
        else {
            validationErrors.partTimeStaffYear1.check = false;
            validationErrors.partTimeStaffYear1.errorMessage = 'The amount seems high. If you have so many part-time employees it might be difficult to meet the requirements.';
        }
        validationErrors.partTimeStaffYear1.show = !isPartTimeStaffYear1Valid;
        this.setState({
            partTimeStaffYear1: value,
            validationErrors: validationErrors
        });
    }
    
    handlePartTimeStaffYear2(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPartTimeStaffYear2Valid = value < 41 && value > -1;

        if (isPartTimeStaffYear2Valid) {
            if (this.state.partTimeStaffYear1 > 0 && value > this.state.partTimeStaffYear1 * 2) {
                validationErrors.partTimeStaffYear2.show = true;
                validationErrors.partTimeStaffYear2.check = false;
                validationErrors.partTimeStaffYear2.errorMessage = 'You are predicting to more than doubling your part-time staff. You will need to provide very good reasons.';
            }
            else {
                validationErrors.partTimeStaffYear2.show = false;
                validationErrors.partTimeStaffYear2.check = true;
                validationErrors.partTimeStaffYear2.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.partTimeStaffYear2', value);
        }
        else {
            validationErrors.partTimeStaffYear2.show = true;
            validationErrors.partTimeStaffYear2.check = false;
            validationErrors.partTimeStaffYear2.errorMessage = 'The amount does not seem right. It is almost certainly no more than double of what you have now.';
        }
        this.setState({
            partTimeStaffYear2: value,
            validationErrors: validationErrors
        });
    }
    
    handlePartTimeStaffYear3(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPartTimeStaffYear3Valid = value < 61 && value > -1;

        if (isPartTimeStaffYear3Valid) {
            if (this.state.partTimeStaffYear2 > 0 && value > this.state.partTimeStaffYear2 * 2) {
                validationErrors.partTimeStaffYear3.show = true;
                validationErrors.partTimeStaffYear3.check = false;
                validationErrors.partTimeStaffYear3.errorMessage = 'You are predicting to more than doubling your staff from the previous year. You will need to provide very good reasons.';
            }
            else {
                validationErrors.partTimeStaffYear3.show = false;
                validationErrors.partTimeStaffYear3.check = true;
                validationErrors.partTimeStaffYear3.errorMessage = '';
            }
            localStorage.setItem('tovsForm.outcomes.partTimeStaffYear3', value);
        }
        else {
            validationErrors.partTimeStaffYear3.show = true;
            validationErrors.partTimeStaffYear3.check = false;
            validationErrors.partTimeStaffYear3.errorMessage = 'The amount does not seem right. It is almost certainly no more than triple of what you have now.';
        }
        this.setState({
            partTimeStaffYear3: value,
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }


    generateViewProps() {
        return {
            ...this.state,
            // Projected Outcomes
            handleMarketExpansion: this.handleMarketExpansion,
            handleTurnoverYear1: this.handleTurnoverYear1,
            handleTurnoverYear2: this.handleTurnoverYear2,
            handleTurnoverYear3: this.handleTurnoverYear3,
            handleFullTimeStaffYear1: this.handleFullTimeStaffYear1,
            handleFullTimeStaffYear2: this.handleFullTimeStaffYear2,
            handleFullTimeStaffYear3: this.handleFullTimeStaffYear3,
            handlePartTimeStaffYear1: this.handlePartTimeStaffYear1,
            handlePartTimeStaffYear2: this.handlePartTimeStaffYear2,
            handlePartTimeStaffYear3: this.handlePartTimeStaffYear3,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <ProjectedOutcomesView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const ProjectedOutcomesContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedProjectedOutcomesContainer));

export default ProjectedOutcomesContainer;